export default "__VITE_ASSET__CZBhZ_ii__"